
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor/governance",
      function () {
        return require("private-next-pages/investor/governance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor/governance"])
      });
    }
  